import api from "./Api";

class FornecedorEnderecoService {
  GetFornecedorEndereco(payload) {
    return api.get("/v1/fornecedorEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  PostFornecedorEndereco(payload) {
    return api.post("/v1/fornecedorEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  PutFornecedorEndereco(payload) {
    return api.put("/v1/fornecedorEndereco/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteFornecedorEndereco(payload) {
    return api.delete("/v1/fornecedorEndereco/" + payload).then((response) => {
      return response.data;
    });
  }

  GetFornecedorEnderecoOData(payload) {
    return api.get("/OData/FornecedorEndereco" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new FornecedorEnderecoService();
